"use client";

import { GoogleLogin } from '@react-oauth/google';
import { useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';
import { googleLoginAction } from '../actions';

export function GoogleLoginButton({ redirectTo }: { redirectTo?: string }) {
  const router = useRouter();
  const [error, setError] = useState<string | null>(null);
  const [isMounted, setIsMounted] = useState(false);

  // Ensure component is mounted on client to access process.env
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleSuccess = async (credentialResponse: any) => {
    try {
      const result = await googleLoginAction(credentialResponse.credential, redirectTo);

      if (result.next) {
        // Successful login, redirect
        router.push(result.next);
      } else if (result.error) {
        setError(result.error);
      }
    } catch (err) {
      console.error('Google Auth Error:', err);
      setError('An unexpected error occurred');
    }
  };

  if (!isMounted) return <div className="h-[44px]" />;

  const clientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

  if (!clientId) {
    return (
      <div className="text-xs text-amber-500 text-center p-2 border border-amber-500/30 rounded bg-amber-500/5 my-2">
        Debug: Google Client ID is missing. Please restart dev server.
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2 w-full min-h-[44px]">
      <div className="w-full flex justify-center">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => {
            console.error('Google Login Script Failed to Render');
            setError('Google login failed');
          }}
          useOneTap
          shape="pill"
          theme="filled_black"
          size="large"
          width="100%"
          text="continue_with"
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
